import { Env, readFromEnv } from '@cinch-nx/environments'

export function getHomepageVariantExperienceSlug(
  experiments: Array<{ name: string; experienceId: number | string }>,
  isInsideStoryblok: boolean,
  slug: string,
  variantSlug: string,
): string {
  const isABEnabled = readFromEnv(Env.EnableHomepageAiSearch) === 'true'
  if (!isABEnabled || isInsideStoryblok) {
    return slug
  }

  const homepageExperiment = experiments.find(
    ({ name }) => name === readFromEnv(Env.AiSearchExperimentId),
  )

  if (!homepageExperiment) {
    return slug
  }
  const experienceId = Number(homepageExperiment.experienceId)
  return experienceId === 1 ? variantSlug : slug
}
